import script from "./ViewASite.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewASite.vue?vue&type=script&setup=true&lang=js"

import "./ViewASite.vue?vue&type=style&index=0&id=648ba12a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-648ba12a"]])

export default __exports__